import CommonService from "./common.service";

const sellerDashboardService = {
  getDashboard: ({ dateFrom, dateTo, module } = {}) => {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (module) params.module = module;
    return CommonService.get("/seller/dashboard", params);
  },
  getTabNotificationCounts: () =>
    CommonService.get("/seller/dashboard/tab-notifications", {}, { silent: true }),
};

export default sellerDashboardService;
